




































// @ is an alias to /src

import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

import OrganizationModel from "@/model/Organization";
import ReportModel from "@/model/Report";
import ModelFactory from "@/model/ModelFactory";
import ReportApi from "@/api/Report";

import SummaryCharts from "@/components/Summary/Charts.vue";
import SummaryTable from "@/components/Summary/Table.vue";
import SummaryOrganizations from "@/components/Summary/Organizations.vue";
import SummaryAverage from "@/components/Summary/Average.vue";

import BaseSelect from "@/components/Base/Controls/BaseSelect.vue";

import { SummaryServerResponse } from "@/types/global.d";

const AppStore = namespace("App");

@Component({
  components: {
    SummaryCharts,
    SummaryTable,
    SummaryOrganizations,
    SummaryAverage,
    BaseSelect
  }
})
export default class Home extends Vue {
  public organizations: OrganizationModel[] = [];
  public report: ReportModel = ModelFactory.create("ReportModel");

  public selectedYear = 0;

  @AppStore.State
  readonly reportYear!: number;

  @AppStore.Getter("isLoading") isLoading!: boolean;

  mounted() {
    this.getData();
  }

  get yearOptions() {
    const max = this.reportYear;
    const years = [];
    for (let i = 2015; i <= max; i++) {
      years.push({ id: i, name: i });
      this.selectedYear = i;
    }

    return years;
  }

  setYear() {
    this.getData(this.selectedYear);
  }

  get isMobile() {
    const screenWidth = window.innerWidth;
    const mobile = screenWidth < 960;
    return mobile;
  }

  async getData(year?: number) {
    const { report, organizations } = await ReportApi.getReportByYear(
      year
    ).then((res: SummaryServerResponse) => {
      return {
        report: ModelFactory.create("ReportModel", res.object.summary),
        organizations: ModelFactory.create(
          "OrganizationModel",
          res.object.details
        )
      };
    });
    Vue.set(this, "organizations", organizations);
    Vue.set(this, "report", report);
  }
}
